import React, { useEffect, useState, useRef } from 'react';
import { Box } from '@mui/material';

import { makeStyles } from '@mui/styles';

// component
import Header from 'components/Header';
import Footer from 'components/Footer';
import AlertPopup from 'components/AlertPopup';

//action
import { getExchangeRate } from 'context/actions/other';

import useWindowSize from 'utils/useWindowSize';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: '100vh',
    },
    container: {
        flexGrow: 1,
    },

    fixedButtonArea: {
        position: 'fixed',
        bottom: '10%',
    },
    fixedButtonAreaSm: {
        right: 20,
    },

    fixedButtonAreaLg: {
        right: 40,
    },
    fixedButton1: {
        width: 50,
        height: 50,
        borderRadius: 50,
        backgroundColor: 'white',
        boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.3)',
        cursor: 'pointer',
        backgroundImage: 'url(/currency.png)',
        backgroundSize: 'cover',
    },
    fixedButton2: {
        width: 50,
        height: 50,
        borderRadius: 50,
        backgroundColor: 'white',
        boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.3)',
        cursor: 'pointer',
        backgroundImage: 'url(/exchange.png)',
        backgroundSize: 'cover',
    },
    fixedButton3: {
        width: 50,
        height: 50,
        borderRadius: 50,
        backgroundColor: 'white',
        boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.3)',
        cursor: 'pointer',
        backgroundImage: 'url(/up.png)',
        backgroundSize: 'cover',
    },
}));

function useOutsideClick(ref, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
}

export default function HomeLayout({ children }) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.root}>
                <main>
                    <Header />
                    <div className={classes.container}>{children}</div>
                    <Footer />
                </main>
            </div>
            <AlertPopup />
        </>
    );
}
